import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-done-orders',
  templateUrl: './done-orders.component.html',
  styleUrls: ['./done-orders.component.scss']
})
export class DoneOrdersComponent implements OnInit {

  requestType : string = "order";
  orderDone : boolean = true;
  orderDoneReviewed : boolean = true;
  hideActionsColumn : boolean = false;
  title : string = "أوامر الصيانة المكتملة";

  constructor() { }

  ngOnInit() {
  }

}
